<template>
  <div class="content">
    <div class="home" v-if="showHome">
      <div class="heard">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="item-col">
              <span class="label">商品名称 </span>
              <div>
                <el-input
                  style="width: 100%"
                  v-model="querySearch.condition.productName"
                  placeholder="请输入商品名称"
                ></el-input>
              </div></div
          ></el-col>

          <el-col :span="8">
            <div class="item-col">
              <span class="label">上架状态 </span>
              <div>
                <el-select
                  v-model="querySearch.condition.productStatus"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="全部" :value="null"> </el-option>
                  <el-option label="已上架" :value="1"> </el-option>
                  <el-option label="已下架" :value="2"> </el-option>
                </el-select>
              </div></div
          ></el-col>

          <el-col :span="8">
            <div class="item-col">
              <span class="label">展示分类 </span>
              <div>
                <el-select
                  v-model="querySearch.condition.categoryFirstCode"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="search"
                >
                  <el-option
                    v-for="item in categoryList"
                    :key="item.categoryCode"
                    :label="item.categoryName"
                    :value="item.categoryCode"
                  >
                  </el-option>
                </el-select>
              </div></div
          ></el-col>

          <el-col :span="8">
            <div class="item-col">
              <span class="label">积分范围</span>
              <div class="flex flex1 center">
                <el-input
                  style="width: 30%"
                  v-model.number="querySearch.condition.minPoint" @input="value=value.replace(/[^0-9.]/g,'')"
                  placeholder="请输入积分最小值" clearable
                ></el-input>
                <span style="padding: 0 8px;">-</span>
                <el-input
                  style="width: 30%"
                  v-model.number="querySearch.condition.maxPoint" @input="value=value.replace(/[^0-9.]/g,'')"
                  placeholder="请输入积分最大值" clearable
                ></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item-col">
              <span class="label">创建时间</span>
              <div>
                <el-date-picker
                  @change="changeTime"
                  v-model="forceTime"
                  type="datetimerange"
                  range-separator="至"
                  unlink-panels
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['', '23:59:59']"
                >
                </el-date-picker>
              </div>
            </div>
          </el-col>

          <el-col :span="5"
            ><el-button type="primary" icon="el-icon-search" @click="search"
              >查询</el-button
            >
            <el-button type="info" icon="el-icon-refresh" @click="reset"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="main">
        <div class="add-box">
          <el-button
            type="primary"
            plain
            style="font-size: 16px"
            @click="addGoods"
            >添加积分商品</el-button
          >
        </div>
        <div class="main-table" style="position: relative">
          <el-table
            :data="tableList"
            style="position: absolute"
            border
            height="100%"
          >
            <el-table-column type="selection" width="100" align="center">
            </el-table-column>
            <el-table-column
              label="序号"
              type="index"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="productName"
              label="商品名称"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column label="商品照片" align="center" width="150">
              <template slot-scope="scope">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.listImg"
                  :preview-src-list="[scope.row.listImg]"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>

            <el-table-column
              prop="categoryFirstName"
              label="商品分类"
              width="150"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="consumeScore"
              label="兑换积分"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.consumeScore }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="consumePrice" label="商品价格" align="center">
              <template slot-scope="scope">
                <span>¥{{ scope.row.consumePrice }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column
              prop="supplierName"
              label="供应商名称"
              width="100"
              align="center"
            >
            </el-table-column> -->
            <!-- <el-table-column label="评分" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.grade ? scope.row.grade : "暂无" }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              prop="isVipDelivery"
              label="是否支持专项配送"
              width="130"
              align="center"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.isVipDelivery"
                  :active-value="1"
                  :inactive-value="0"
                  disabled
                >
                </el-switch
              ></template>
            </el-table-column>
            <el-table-column
              prop="enterCabinet"
              label="是否入柜"
              align="center"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.enterCabinet"
                  :active-value="1"
                  :inactive-value="0"
                  disabled
                >
                </el-switch
              ></template>
            </el-table-column> -->
            <el-table-column
              prop="productStatus"
              label="状态"
              align="center"
              width="130"
            >
              <template slot-scope="{ row }">
                <el-button v-if="row.productStatus == 1" type="success" plain
                  >已上架</el-button
                >
                <el-button v-if="row.productStatus == 2" type="warning" plain
                  >已下架</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width="160"
              align="center"
            >
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <div>
                  <el-button
                    class="item-elbtn"
                    type="text"
                    size="small"
                    @click="editProduct(row)"
                    >编辑</el-button
                  >
                  <el-button
                    class="item-elbtn"
                    type="text"
                    size="small"
                    style="color: red"
                    @click="deleteProduct(row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div v-if="!showHome">
      <addScorePage @goBack="goBack" :parentId="parentId"></addScorePage>
    </div>
  </div>
</template>
<script>
import addScorePage from './components/addScorePage.vue'
export default {
  components: {
    addScorePage
  },
  data () {
    return {
      parentId: '',
      showHome: true,
      forceTime: [],
      querySearch: {
        condition: {
          startTime: '',
          endTime: '',
          productName: '',
          productStatus: null,
          categoryFirstCode: '',
          minPoint: null,
          maxPoint: null
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      tableList: [],
      count: 0,
      categoryList: []
    }
  },
  watch: {
    'querySearch.condition.minPoint': {
      handler (val) {
        console.log('ma-x', val, val && val >= 0, !this.querySearch.condition.maxPoint)
        if (val && val >= 0) {
          if (!this.querySearch.condition.maxPoint || val > this.querySearch.condition.maxPoint) {
            this.querySearch.condition.maxPoint = val + 100000
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.getProductList()
    this.getAllParentCategoryList()
  },
  methods: {
    goBack () {
      this.parentId = ''
      this.showHome = true
      this.getProductList()
    },
    // 获取所有一级分类
    async getAllParentCategoryList () {
      this.$http
        .post('/productCategory/queryList', {
          level: 1
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.categoryList = res.data.data
          }
        })
    },
    changeTime (data) {
      if (data) {
        this.querySearch.condition.startTime = data[0]
        this.querySearch.condition.endTime = data[1]
      } else {
        this.querySearch.condition.startTime = ''
        this.querySearch.condition.endTime = ''
      }
      // this.getProductList();
    },
    handleCurrentChange (val) {
      this.querySearch.currPage = val
      this.getProductList()
    },
    search () {
      this.querySearch.currPage = 1
      this.getProductList()
    },
    reset () {
      this.querySearch.condition.startTime = ''
      this.querySearch.condition.endTime = ''
      this.forceTime = []
      this.querySearch.condition.productName = ''
      this.querySearch.condition.productStatus = ''
      this.querySearch.condition.categoryFirstCode = ''
      this.querySearch.currPage = 1
      this.querySearch.pageSize = 10
      this.getProductList()
    },
    addGoods () {
      this.showHome = false
    },
    editProduct (row) {
      this.parentId = row.id
      this.showHome = false
    },

    async getProductList () {
      let _this = this
      this.$http
        .post('/productSocre/list', {
          ..._this.querySearch
        })
        .then(function (res) {
          let { code, data } = res.data
          if (code === 200) {
            _this.tableList = data.data
            _this.count = data.count
            _this.$forceUpdate() // 触发强制刷新
          }
        })
    },

    async deleteProduct (row) {
      let _this = this
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/productSocre/delete', {
              id: row.id
            })
            .then(function (res) {
              if (res.data.code == 200) {
                _this.$message({
                  message: '删除成功!',
                  type: 'success'
                })
                _this.getProductList()
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'fail'
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  height: 100% !important;
  .home {
    height: 100% !important;
    display: flex;
    flex-direction: column;
    background-color: #eef1f6;
    padding: 10px;
    box-sizing: border-box;
  }
  .heard {
    background-color: #fff;
    height: auto;
    padding: 15px;
    .item-col {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      .label {
        width: fit-content;
        margin-right: 10px;
      }
      div {
        flex: 1;
      }
    }
  }
  .main {
    margin-top: 20px;
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px;
    .main-table {
      flex: 1;
      overflow: hidden;
    }
    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  position: static !important;
}
/deep/ .el-tabs__active-bar {
  background-color: transparent !important;
}
/deep/ .el-tabs__nav.is-top {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  background-color: #dff0f9;
  overflow-y: auto;
}
/deep/ .item-elbtn {
  margin-left: 0;
  padding: 0 2px;
}
</style>
